import React, { Component } from 'react';
import './style.scss';

class PageHeader extends Component {
  render() {
    const { title, breadcrumbs, className, asSection } = this.props;
    const Wrapper = asSection ? 'section' : 'div';

    return (
      <Wrapper className={`page-header ${className || ''}`}>
        <div className="breadcrumbs">
          {breadcrumbs}
          <span className="page-header__inner">{title}</span>
        </div>
      </Wrapper>
    );
  }
}

export default PageHeader;
